// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import 'zone.js/dist/zone-error';

export const environment = {
  production: false,
  apiUrl: 'https://api.pragamana.com:8443/cpq' // when server is on cloud
  // apiUrl: 'http://172.16.16.25:8443/cpq' // for imtechnologies offline setup
  // apiUrl: 'http://localhost:8443/cpq'
};

// https://stackoverflow.com/questions/34986922/define-global-constants

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
